export class GenCustomerEntity{
    id:number;
    code:string;
    description:string;
    incomeActive:boolean;
    active:boolean;

    constructor(){}
}